const contentNameEnToFr = {
  'Emergency call handlers': 'Gestion des appels d\'urgence',
  Gastroenterology: 'Gastro-entérologie',
  'Hygiene and Infectious diseases': 'Hygiène et maladies infectieuses',
  'The nursing profession - Demo': 'La profession infirmière - Démo',
  'Podiatry: High risk feet': 'Podologie : Pieds à haut risque',
  'Midwifery: Obstetric gynaecology': 'Sage-femme : Gynécologie obstétricale',
  'Pain assessment and management': 'Évaluation et gestion de la douleur',
  'The Hospital Environment': 'Le milieu hospitalier',
  'Anatomy and Physiology': 'Anatomie et physiologie',
  'The Pediatric nurse': 'L\'infirmière pédiatrique',
  Anesthesia: 'Anesthésie',
  'Introduction to radiology': 'Introduction à la radiologie',
  'Abstract writing IADE v2': 'Rédaction d\'abstract IADE',
  'Introduction to podiatry': 'Introduction à la podologie',
  'Midwifery: Postnatal care': 'Soins obstétricaux : Soins postnatals',
  'MSD - musculoskeletal disorders': 'TMS - troubles musculo-squelettiques',
  'Introduction to midwifery': 'Introduction à la pratique de sage-femme',
  'Content Level 1': 'Contenu niveau 1',
  'Introduction to anesthesiology': 'Introduction à l\'anesthésiologie',
  'Understanding scientific publications': 'Comprendre les publications scientifiques',
  'Physiotherapy: MSD - musculoskeletal disorders': 'Physiothérapie : TMS - troubles musculo-squelettiques',
  Ethics: 'Éthique',
  'Abstract writing IADE': 'Rédaction d\'abstract IADE',
  'Podiatry: Common foot problems': 'Podologie : Problèmes de pieds courants',
  'Pediatric nursing: Child development': 'Soins infirmiers pédiatriques : Développement de l\'enfant',
  'Neurological disorders and physiotherapy': 'Troubles neurologiques et physiothérapie',
  Abstracts: 'Abstracts',
  'Medication and Medical Equipment': 'Médicaments et matériel médical',
  'The nursing profession': 'Le métier d\'infirmière',
  'Pediatric nursing: Childhood diseases and Illnnesses': 'Soins infirmiers pédiatriques : Maladies et affections infantiles',
  'Radiology: Communicating with patients': 'Radiologie : Communication avec les patients',
  'Podiatry: Lower limb anatomy': 'Podologie : Anatomie des membres inférieurs',
  'Sports podiatry': 'Podologie du sport',
  'Introduction to psychomotricity': 'Introduction à la psychomotricité',
  'Pediatrics and Podiatry': 'Pédiatrie et podologie',
  'Physiotherapy: Lower limb anatomy': 'Physiothérapie : Anatomie des membres inférieurs',
  'Pediatric nursing: Disease education and prevention': 'Soins infirmiers pédiatriques : éducation et prévention des maladies',
  'Introduction to physiotherapy': 'Introduction à la physiothérapie',
  'Ethics v2': 'Ethique',
  'Presenting - Demo': 'Présentation - Démo',
  'Psychomotricity: Pain assessment and treatment': 'Psychomotricité : Évaluation et traitement de la douleur',
  'Podiatry: Care of the elderly foot': 'Podologie : Soins des pieds des personnes âgées',
  'Abstract writing physiotherapy': 'Rédaction d\'abstract - physiothérapie',
  'Pediatric physiotherapy': 'Physiothérapie pédiatrique',
  'Mental Illness': 'Maladie mentale',
  'Nutrition and Obesity': 'Nutrition et obésité',
  'Patient admissions': 'Admissions de patients',
  'Midwifery: Childbirth and labour': 'Sage-femme : accouchement',
  'Physiotherapy: Abstract wrting': 'Physiothérapie : Rédaction d\'abstract',
  'Cardiorespiratory physiotherapy': 'Physiothérapie cardiorespiratoire',
  Summarizing: 'Résumer',
  'Emergency situations': 'Situations d\'urgence',
  Presenting: 'Présentation ',
  'Midwifery: Neonatology and pediatrics': 'Sage-femme : néonatologie et pédiatrie',
  'Anesthesiology: Medication and equipment': 'Anesthésiologie : Médicaments et matériel',
  'Podiatry: Gait assessment': 'Podologie : Évaluation de la démarche',
  'Physiotherapy: Gait Assessment': 'Physiothérapie : Évaluation de la démarche',
  Cardiology: 'Cardiologie',
  'Content Level 2': 'Contenu Niveau 2',
  Surgery: 'Chirurgie',
  'Physiotherapy: Pain assessment and treatment': 'Physiothérapie : Évaluation et traitement de la douleur',
  'Grammar Review': 'Révisions grammaticales',
  'The Hospital Environment - Demo': 'L\'environnement hospitalier - Démo',
  Translating: 'Traduction',
  'Psychomotricity: Introduction to psychomotricity': 'Psychomotricité : Introduction à la psychomotricité',
  'Podiatry: Treatment and equipment': 'Podologie : Traitement et équipement',
  'Pediatric nursing: Check ups, exams and vaccinations': 'Soins infirmiers pédiatriques : bilans de santé, examens et vaccinations',
  'Presenting 2': 'Présentation',
  'Treatment and equipment in physiotherapy': 'Traitement et équipement en physiothérapie',
  'Sports and physiotherapy': 'Sport et physiothérapie',
  Anatomy: 'Anatomie',
  'Anesthesia complications': 'Complications de l\'anesthésie',
  'Radiology: Specific exams and treatements': 'Radiologie : Examens et traitements spécifiques',
  'Midwifery: The antenatal period': 'Soins obstétricaux : La période prénatale',
  'Patient admissions - Demo': 'Admissions des patients - Démo',
  'Diseases and symptoms': 'Maladies et symptômes',
  'Podiatry:Common foot problems': 'Podologie : Problèmes de pieds courants',
  'Physiotherapy- Revision chapter': 'Physiothérapie - Chapitre de révision',
  'Summarizing V2 IBODE': 'Résumé',
  'The Perioperative Nurse': 'L\'infirmière périopératoire',
  'Abstract writing IBODE': 'Rédaction d\'abstract IBODE',
  'Ethics IBODE': 'Ethique IBODE',
  'Physiotherapy in different English speaking countries': 'La physiothérapie dans différents pays anglophones',
  'Physiotherapy & palliative care': 'Physiothérapie et soins palliatifs',
  'Physiotherapy & geriatric care': 'Physiothérapie et soins gériatriques',
  'SOCIAL WORKERS - MIGRATION': 'Travailleurs sociaux - Migration',
  'International mobility': 'Mobilité internationale',
  'Social work and child protection': 'Travail social et protection de l\'enfance',
  'Social work and migration': 'Travail social et migration',
  'Social work and precarious situations': 'Travail social et situations précaires',
  'Social work and the family unit': 'Le travail social et l\'unité familiale',
  'Social work and the protection of adults': 'Le travail social et la protection des adultes',
  'Social Work and People, Places, and Paperwork': 'Le travail social : personnes, lieux et démarches administratives',
  'Social Work and Dependency and Autonomy': 'Travail social, dépendance et autonomie ',
  'Hospital Pharmacy: Dispensing and Communicating': 'Pharmacie hospitalière : dispensation et communication',
  'Hospital Pharmacy: Compounding medication': 'Pharmacie hospitalière : Préparation de médicaments',
  'Hospital Pharmacy: Hygiene, Sterilisation and Waste management': 'Pharmacie hospitalière : hygiène, stérilisation et gestion des déchets',
  'Hospital Pharmacy: Safety and Risk Prevention': 'Pharmacie hospitalière : sécurité et prévention des risques',
  'Understanding Professional Documents': 'Comprendre des documents professionnels',
  'Communicating with patients': 'Communiquer avec les patients',
  'Introduction to Healthcare': 'Introduction à la santé',
  'Presenting Online': 'Présentation en ligne',
  // ... ajoute ici tous tes titres
};

export default contentNameEnToFr;
